import { render, staticRenderFns } from "./NotificationsItem.vue?vue&type=template&id=3892a4ae&scoped=true&"
import script from "./NotificationsItem.vue?vue&type=script&lang=js&"
export * from "./NotificationsItem.vue?vue&type=script&lang=js&"
import style0 from "./NotificationsItem.vue?vue&type=style&index=0&id=3892a4ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3892a4ae",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/ui/NotificationsItem.vue
// module id = null
// module chunks = 